import React, { useContext, useState } from "react";
import logo from "../../assets/company-logo.svg";
import poster from "../../assets/login_poster.png";
import { CommonContext } from "hooks/CommonContext";

const Login = () => {
  // Form state
  const { setUserOwnData, setIsLoggedIn } = useContext(CommonContext);
  const [participantUserData, setParticipantUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [errors, setErrors] = useState({});

  // Handle input change
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setParticipantUserData({
      ...participantUserData,
      [id]: value,
    });
  };

  // Email validation regex
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validateForm = () => {
    let formErrors = {};
    if (!participantUserData.firstName.trim()) {
      formErrors.firstName = "First Name is required";
    }
    if (!participantUserData.lastName.trim()) {
      formErrors.lastName = "Last Name is required";
    }
    if (!participantUserData.email.trim()) {
      formErrors.email = "Email is required";
    } else if (!validateEmail(participantUserData.email)) {
      formErrors.email = "Invalid email format";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // If validation passes, submit the form
      setUserOwnData((previousData) => ({
        ...previousData,
        username:
          participantUserData.firstName + " " + participantUserData.lastName,
        fname: participantUserData.firstName,
        lname: participantUserData.lastName,
        email: participantUserData.email,
      }));
      setIsLoggedIn(true);
    }
  };

  return (
    <div className="row p-0 m-0 d-flex justify-content-between">
      <div className="col-7 p-2" style={{ height: "100vh" }}>
        <img
          src={poster}
          style={{ width: "100%", height: "100%" }}
          alt="poster"
        />
      </div>
      <div className="col-5">
        <div className="login-box-container px-5">
          <div className="d-flex justify-content-center my-5">
            <img src={logo} alt="logo" />
          </div>
          <h1 className="text-center ni-text-primary mb-3">Login</h1>
          <div className="text-center text-muted mb-3">
            Welcome to Niyantras One. Please enter your details to use the
            Interview portal.
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group mt-2">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                className={`form-control ${
                  errors.firstName ? "is-invalid" : ""
                }`}
                id="firstName"
                value={participantUserData.firstName}
                onChange={handleInputChange}
                placeholder="Enter first name"
              />
              {errors.firstName && (
                <div className="invalid-feedback">{errors.firstName}</div>
              )}
            </div>

            <div className="form-group mt-2">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                className={`form-control ${
                  errors.lastName ? "is-invalid" : ""
                }`}
                id="lastName"
                value={participantUserData.lastName}
                onChange={handleInputChange}
                placeholder="Enter last name"
              />
              {errors.lastName && (
                <div className="invalid-feedback">{errors.lastName}</div>
              )}
            </div>

            <div className="form-group mt-2">
              <label htmlFor="email">Email</label>
              <input
                type="text"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                id="email"
                value={participantUserData.email}
                onChange={handleInputChange}
                placeholder="Enter email"
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-lg w-100 ni-btn-primary mt-5"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
